const DATA = [
  {
    id: 79,
    title: 'Explanations when no solutions can be found',
    venue:
      'Invited Talk at the HRI 2024 Workshop on Explainability for Human-Robot Collaboration',
    link: 'https://humanrobotinteraction.org/2024',
  },
  {
    id: 80,
    title: 'Model Acquisition in the Modern Era',
    venue: 'ICAPS 2023 Tutorial with Professor Christian Muise',
    link: 'https://icaps23.icaps-conference.org/program/tutorials/model',
  },
  {
    id: 81,
    title:
      'How to React to Unsolvable Problems: On Model Space Reasoning and Large Language Models for Automated Planning',
    venue:
      'Invited Talk at the ICRA 2023 Workshop on Robot Execution Failures and Failure Management Strategies',
    link: 'https://robot-failures.github.io/icra2023/schedule',
  },
  {
    id: 82,
    title: 'Challenges in Recognising and Analysing Execution Failures',
    venue:
      'Panel and Interactive Session at the ICRA 2023 Workshop on Robot Execution Failures and Failure Management Strategies',
    link: 'https://robot-failures.github.io/icra2023/schedule',
  },
  {
    id: 83,
    title: 'Planning with Mental Models: Explanations and Explainability',
    venue: 'Invited Talk at the ICRA 2023 Workshop on Explainable Robotics',
    link: 'https://nms.kcl.ac.uk/icra2023.explainablerobotics/#schedule',
  },
  {
    id: 84,
    title: 'Challenges in Explainable Robotics',
    venue: 'Panel at the ICRA 2023 Workshop on Explainable Robotics',
    link: 'https://nms.kcl.ac.uk/icra2023.explainablerobotics/#schedule',
  },
  {
    id: 85,
    title: 'Emergent Process Composition from Natural Language Inputs',
    venue: 'BPM 2022 RPA Forum Keynote',
    link: 'https://bpm2022.uni-muenster.de/calls-and-dates/call-for-rpa-forum',
  },
  {
    id: 86,
    title: 'Explanations as an Interactive Dialogue',
    venue: 'Panel at ICAPS 2022 Workshop on Explainable AI Planning',
    link: 'http://xaip.mybluemix.net/2022',
  },
  {
    id: 87,
    title:
      'Exploration of innovative ways in which data and digital / hybrid tools can be used to develop multidimensional stories focused on health crises: The COVID-19 India Dataset',
    venue: 'Panel at Fridays at Proto',
    link: 'https://twitter.com/heyproto/status/1471870555754143745',
  },
  {
    id: 88,
    title:
      'Automated Planning and Business Process Automation - A Practitioners Guide',
    venue: 'BPM 2021 Tutorial',
    link: 'http://ibm.biz/bpm-2021-tutorial',
  },
  {
    id: 89,
    title: 'Explainability of Sequential Decision-Making Models',
    venue: 'XAI Bootscamp at the Robert Bosch Centre for Data Science and AI',
    link: 'https://rbcdsai.iitm.ac.in/Bootcamp-DAI',
  },
  {
    id: 90,
    title: 'Designing Goal-Oriented Conversational Agents',
    venue: 'Industry Talk at ICAPS 2021',
    link: 'https://icaps21.icaps-conference.org/Schedule/index.html',
  },
  {
    id: 91,
    title: 'Explainable Agents - Escape from the Ivory Tower',
    venue:
      'Panel at Workshop on EXplainable and TRAnsparent AI and Multi-Agent Systems (EXTRAAMAS)',
    link: 'https://extraamas.ehealth.hevs.ch/archive.html',
  },
  {
    id: 92,
    title: 'Career Panel',
    venue: 'AAMAS 2021 Doctoral Consortium',
    link:
      'https://aamas2021.soton.ac.uk/programme/doctoral-consortium-programme/',
  },
  {
    id: 93,
    title: 'A Crash Course in Designing Interpretable Agent Behavior',
    venue:
      'Invited Talk at HRI 2021 Workshop on Solutions For Socially Intelligent HRI in Real-World Scenario',
    link: 'https://sites.google.com/view/realworldhri-workshop/home',
  },
  {
    id: 94,
    title:
      'How Symbolic AI and ML can Combine for the Design of Conversational Agents at Scale',
    venue:
      'Invited Talk at AAAI 2021 Workshop on Reasoning and Learning for Human-Machine Dialogues',
    link: 'https://sites.google.com/view/deep-dial2021/',
  },
  {
    id: 95,
    title: 'Automated Composition of Aggregate Assistants',
    venue:
      'Invited Talk at CASCON x Evoke 2020 Workshop on Automation, Control, and Analysis of Knowledge-intensive Processes',
    link: 'https://pheedloop.com/casconevoke2020/site/sessions/?id=XDuXBf',
  },
  {
    id: 96,
    title: 'XAI for Planning and Scheduling',
    venue: 'Airbus Tech Talk',
  },
  {
    id: 97,
    title: '404. Expected plan not found',
    venue:
      'Invited Talk at ICRA 2020 Workshop on Against Robot Dystopias: Thinking Through the Ethical, Legal and Societal Issues of Robotics and Automation',
    link:
      'https://www.youtube.com/playlist?list=PLgMdNXv0Fp8ydyIDoFQtHrTCdkkkjEoCP',
  },
  {
    id: 98,
    title:
      'Synthesizing Explainable and Deceptive Behavior for Human-AI Interaction',
    venue:
      'AAAI 2020 Tutorial with Professor Subbarao Kambhampati, Sarath Sreedharan, and Anagha Kulkarni',
    link: 'https://yochan-lab.github.io/tutorial/AAAI-2020/',
  },
  {
    id: 99,
    title: 'When Planners Meet People: Challenges and Lessons Learned',
    venue: 'MIT-IBM Lab Research Seminar Series',
  },
  {
    id: 100,
    title: 'Planning in a Multi-Model Setting: Explanations and Explicability',
    venue:
      'Invited Talk at HRI 2019 Workshop on Test Methods and Metrics for Effective HRI in Collaborative Human Robot Teams',
  },
];

export default DATA;
